import {Button} from '@wandb/weave/components/Button';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import * as PanelTypes from '../../state/views/panel/types';
import * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {
  useWorkspaceDrawerContextMaybe,
  WorkspaceDrawerContextType,
} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';
import {useDetectPanelVariant} from './hooks';
import {StyledButtonWrapper} from './PanelActions.style';

export const PanelRunMetricButton = ({
  panelBankSectionConfigRef,
  panelRef,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref | undefined;
  panelRef: PanelTypes.Ref;
}) => {
  const {isFullScreenPanelPage} = useDetectPanelVariant();
  const workspaceDrawerContext = useWorkspaceDrawerContextMaybe();

  let openWorkspaceDrawer:
    | undefined
    | WorkspaceDrawerContextType['openWorkspaceDrawer'] = undefined;

  if (workspaceDrawerContext) {
    openWorkspaceDrawer = workspaceDrawerContext.openWorkspaceDrawer;
  }

  return (
    <Tooltip
      content={
        <div className="flex items-center gap-4">Create alert automation</div>
      }
      position="top center"
      trigger={
        <StyledButtonWrapper>
          <Button
            icon="bell-notifications"
            variant="ghost"
            aria-label="Create alert automation"
            size={isFullScreenPanelPage ? 'medium' : 'small'}
            onClick={() => {
              openWorkspaceDrawer?.(
                'create-trigger',
                panelBankSectionConfigRef,
                panelRef
              );
            }}
          />
        </StyledButtonWrapper>
      }
    />
  );
};
